define('lq/typesProvider',[
    'underscore'
], function (_) {
    'use strict';

    var TypesProvider = function(listOfTypes) {
        this.types = _.reduce(
            listOfTypes,
            function (memo, type) {
                var typeName = type.typeName;

                if (!typeName) {
                    var parentPrototype = Object.getPrototypeOf(type.prototype);
                    typeName = parentPrototype.constructor.typeName;
                }
                
                if (!typeName)
                    throw new Error('Type does not have a name.');

                if (memo[typeName])
                    throw new Error('More than 1 type found with name ' + typeName + '.');

                memo[typeName] = type;
                return memo;
            },
            {});
    };

    TypesProvider.prototype.get = function(typeName) {
        var type = this.types[typeName];

        if (!type)
            throw new Error('Type ' + typeName + ' was not found.');

        return type;
    };

    return TypesProvider;
});
